import { render, staticRenderFns } from "./ModalCreateCategoryBill.vue?vue&type=template&id=2d8382f8&scoped=true&"
import script from "./ModalCreateCategoryBill.vue?vue&type=script&lang=js&"
export * from "./ModalCreateCategoryBill.vue?vue&type=script&lang=js&"
import style0 from "./ModalCreateCategoryBill.vue?vue&type=style&index=0&id=2d8382f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8382f8",
  null
  
)

export default component.exports